import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../utils/api'
import { useCart } from '../context/CartContext'

function ProductList() {
  const [products, setProducts] = useState([])
  const [categories, setCategories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState('')
  const [loading, setLoading] = useState(true)
  const { addToCart } = useCart()
  const { category } = useParams()

  useEffect(() => {
    if (category) {
      setSelectedCategory(category)
    }
    loadProducts()
    loadCategories()
  }, [category])

  useEffect(() => {
    loadProducts()
  }, [selectedCategory])

  const loadProducts = async () => {
    try {
      setLoading(true)
      const productsData = await api.getProducts(selectedCategory)
      setProducts(productsData)
    } catch (error) {
      console.error('Failed to load products:', error)
    } finally {
      setLoading(false)
    }
  }

  const loadCategories = async () => {
    try {
      const categoriesData = await api.getCategories()
      setCategories(categoriesData)
    } catch (error) {
      console.error('Failed to load categories:', error)
    }
  }

  const handleCategoryChange = (category) => {
    setSelectedCategory(category)
  }

  if (loading) {
    return <div className="container">Loading...</div>
  }

  return (
    <div className="container">
      <div className="products-header">
        <h1>Our Products</h1>
        
        {/* Category Filter */}
        <div className="category-filter">
          <button
            className={`category-btn ${selectedCategory === '' ? 'active' : ''}`}
            onClick={() => handleCategoryChange('')}
          >
            All Products
          </button>
          {categories.map(cat => (
            <button
              key={cat.id}
              className={`category-btn ${selectedCategory === cat.name ? 'active' : ''}`}
              onClick={() => handleCategoryChange(cat.name)}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      <div className="products-grid">
        {products.map(product => (
          <div key={product.id} className="product-card">
            <img
              src={product.image || '/placeholder-image.jpg'}
              alt={product.name}
              className="product-image"
              onError={(e) => {
                e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y0ZjRmNCIvPjx0ZXh0IHg9IjEwMCIgeT0iMTAwIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTQiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiIGZpbGw9IiM5OTkiPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg==';
              }}
            />
            {product.category && (
              <div className="product-category">{product.category}</div>
            )}
            <h3>{product.name}</h3>
            <p className="product-price">${product.price}</p>
            <p className="product-description">{product.description}</p>
            <button
              className="btn"
              onClick={() => addToCart(product)}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>

      {products.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666', margin: '2rem 0' }}>
          No products found{selectedCategory ? ` in ${selectedCategory}` : ''}.
        </p>
      )}
    </div>
  )
}

export default ProductList
